import { relations } from 'drizzle-orm';
import { boolean, index, integer, pgTable, serial, text, timestamp, uniqueIndex } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import { account } from './account';
import { apiKey } from './api-key';
import { applicationSetting } from './application-setting';
import { hostedAuthApplicationDomain } from './hosted-auth-domain';
import { organization } from './organization';
import { rateLimitSetting } from './rate-limit';
import { accountScope } from './scope';
import { trackingApplicationDomain } from './tracking-domain';
import { webhookEndpoint } from './webhook-endpoint';

export const application = pgTable(
  'application',
  {
    id: serial().primaryKey(),
    public_id: typeId('app', 'public_id').notNull(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    organization_id: integer()
      .notNull()
      .references(() => organization.id),
    production: boolean().notNull().default(true),
    name: text().notNull(),
  },
  (t) => [
    uniqueIndex('application_public_id_uq').on(t.public_id),
    uniqueIndex('application_id_organization_id_uq').on(t.id, t.organization_id),
    index('application_organization_id_idx').on(t.organization_id),
  ],
);

export const applicationRelations = relations(application, ({ many, one }) => ({
  settings: many(applicationSetting),
  hostedAuthApplicationDomains: many(hostedAuthApplicationDomain),
  trackingApplicationDomains: many(trackingApplicationDomain),
  endpoints: many(webhookEndpoint),
  accounts: many(account),
  scopes: many(accountScope),
  apiKeys: many(apiKey),
  organization: one(organization, { fields: [application.organization_id], references: [organization.id] }),
  rateLimitSettings: many(rateLimitSetting),
}));
